export const splitWord = (word = '') => word.split('').map((letter, i) => ({ key: `${letter}-${i}`, letter }));
